import React from 'react';
import { Input } from 'tfc-components';

import Icon from 'components/atoms/Icon';

interface SearchBarProps {
  onChange: (string: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onChange, placeholder }) => (
  <div className="m-searchBar">
    <Icon
      iconName="search"
      size="20"
    />
    <Input
      placeholder={placeholder || 'Search'}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default SearchBar;
